export const cards = [
  {
    title: "Social Media Campaigns",
    description:
      "Use platforms like Facebook and LinkedIn to reach potential traders.",
  },
  {
    title: "Influencer Partnerships",
    description: "Collaborate with trading influencers to promote your app.",
  },
  {
    title: "Search Engine Optimization (SEO)",
    description:
      "Optimize your website with keywords like Zerodha clone app to attract organic traffic.",
  },
  {
    title: "Referral Programs",
    description: "Encourage existing users to bring new users through rewards.",
  },
];

export const descriptions = [
  "Determine the purpose of your Zerodha clone app. Identify your target audience and the features they need.",
  "Select a development team experienced in building trading apps. Their expertise ensures smooth development and compliance with regulations.",
  "Work on an intuitive and attractive UI. Make sure the app is simple to use, even for those new to trading.",
  "Incorporate essential features like market data, order placement, and analytics. Focus on delivering accuracy and speed.",
  "Security is crucial in financial apps. Implement encryption, two-factor authentication, and additional security measures to safeguard user data.",
  "Thoroughly test your Zerodha clone app for bugs and glitches. After testing, launch it on platforms like Android and iOS.",
];

export const leftItems = [
  "Define Your Goals",
  "Choose the Right Development Partner",
  "Design the User Interface",
  " Integrate Trading Features",
  "Ensure Security",
  "Test and Launch",
];

export const images = [
  require("../../../image/zerodha/dev-img-six.webp"),
  require("../../../image/zerodha/dev-img-one.webp"),
  require("../../../image/zerodha/dev-img-two.webp"),
  require("../../../image/zerodha/dev-img-three.webp"),
  require("../../../image/zerodha/dev-img-four.webp"),
  require("../../../image/zerodha/dev-img-five.webp"),
  require("../../../image/zerodha/dev-img-six.webp"),
];
